import { Link } from "react-router-dom";
import { ROUTES } from "@/config/routes";
import { site } from "@/config/site";
import { PLAN_NAV_LABEL } from "@/features/billing/planCopy";

export function WelcomeCard() {
  return (
    <div className="welcome-card">
      <div>
        <h2>Welcome back</h2>
        <div className="welcome-card-lead">
          <p>Connected Stripe account · export invoices and receipts for finance.</p>
          <p className="welcome-card-custom">
            Email us for custom features:{" "}
            <a
              href={`mailto:${site.supportEmail}?subject=InvoiceVault%20custom%20feature`}
              className="link-quiet"
            >
              {site.supportEmail}
            </a>
          </p>
        </div>
      </div>
      <div className="mt-4 flex flex-wrap gap-2">
        <Link to={ROUTES.invoicesPdfs} className="btn-main">
          Download Invoice PDFs
        </Link>
        <Link to={ROUTES.exports} className="btn-soft">
          Export History
        </Link>
        <Link to={ROUTES.billing} className="btn-soft">
          {PLAN_NAV_LABEL}
        </Link>
      </div>
    </div>
  );
}
